<div class="overlay" *ngIf="loadState">
  <mat-spinner class="loading"></mat-spinner>
</div>
